const SERVER_URL = "https://myprojectbackend-three.vercel.app";

export const SHORTEN_URL = SERVER_URL + "/shorten";
export const REDIRECT_URL = SERVER_URL + "/redirect/";
